import React, { useEffect } from "react";
import Streaming from "../../common/live-tracker/Streaming";
import { getMatchStreamingProps, getStreamingId } from "../../data/streaming/streamingUtils";
import { useStreaming } from "../../common/live-tracker/StreamingProvider";

export default function MultiliveStreaming(props) {
    const streaming = useStreaming();
    const event = props.data;

    useEffect(() => {
        let streamingId = null;
        const streamingMap = getMatchStreamingProps(event);
        if (streamingMap != null) {
            streamingId = getStreamingId(streamingMap[event.id]);
        }
        streaming.toggleStreamingId(streamingMap[event.id], streamingId, event.id);

        function close() {
            streaming.toggleStreamingId(null, null, null);
        }

        window.addEventListener('xs-close-streaming', close);

        return () => {
            window.removeEventListener('xs-close-streaming', close);
        };
    }, []);

    return (
        <Streaming />
    );
}
